import type { ReactNode } from 'react';
import { SignUpHeader } from '@hotjar/webapp/components/SignUpHeader';
import { tokens } from '@hotjar/hotsauce';
import { css } from '@emotion/react';

import { SideContent } from './SideContent';
import { Container, FormWrapper, RowWrapper, SideWrapper } from '../styles';

export type LoginTemplateProps = {
  children: ReactNode;
  className?: string;
  id?: string;
};

export const LoginLayout = ({ children, ...props }: LoginTemplateProps): JSX.Element => {
  return (
    <Container {...props}>
      <SignUpHeader />
      <RowWrapper>
        <FormWrapper>{children}</FormWrapper>
        <SideWrapper
          css={css`
            background: ${tokens.BRAND_COLORS.cobalt_200};
          `}
        >
          <SideContent />
        </SideWrapper>
      </RowWrapper>
    </Container>
  );
};
